import { render, staticRenderFns } from "./OtherDeposit.vue?vue&type=template&id=1ca99281"
import script from "./OtherDeposit.vue?vue&type=script&lang=js"
export * from "./OtherDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports